import { css } from 'linaria';

export const bathroomCollectionsStepsAccordion = css`
  && {
    @media (--only-large-desktop) {
      width: 877px;
    }
  }
`;

export const bathroomCollectionsStepTitle = css`
  && {
    position: relative;
    padding-left: 56px;

    &::before {
      position: absolute;
      top: 34px;
      left: 26px;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      content: '';
    }

    @media (--only-mobile) {
      & h3 {
        font-size: 16px;
        line-height: 24px;
      }

      &::before {
        top: 18px;
        left: 18px;
      }
    }
  }
`;

export const bathroomCollectionsStepDescription = css`
  && {
    @media (--from-desktop) {
      width: 765px;
    }

    @media (--only-tablet) {
      width: 548px;
    }

    @media (--only-mobile) {
      width: 100%;
      margin-bottom: 8px;
    }
  }
`;

export const bathroomCollectionsStepTitleFirst = css`
  && {
    &::before {
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-collections/steps/1.jpg/1.jpg');
    }
  }
`;

export const bathroomCollectionsStepTitleSecond = css`
  && {
    &::before {
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-collections/steps/2.jpg/2.jpg');
    }
  }
`;

export const bathroomCollectionsStepTitleThird = css`
  && {
    &::before {
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-collections/steps/3.jpg/3.jpg');
    }
  }
`;

export const bathroomCollectionsStepTitleFourth = css`
  && {
    &::before {
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-collections/steps/4.jpg/4.jpg');
    }
  }
`;

export const bathroomCollectionsStepLink = css`
  && {
    display: inline;
    color: var(--brand-dark);

    &:hover {
      color: var(--control-hover-accent);
    }
  }
`;

export const bathroomCollectionsStepButton = css`
  margin-top: 24px;

  @media (--only-mobile) {
    margin-top: 16px;
  }
`;
